import * as angular from 'angular';

export class HousingAssociationsFactory {
    private apiRoot: string = '/api/v1/housing_associations';
    private $http;

    constructor($http) {
        this.$http = $http;
    }

    readIssues(id, params) {
        return this.$http.get(
            `${this.apiRoot}/${id}/issues/`,
            { params }
        );
    }

    addIssue(id, value) {
        return this.$http.post(
            `${this.apiRoot}/${id}/issues/`,
            value
        );
    }

    readJournal(ha_id, issue_id, params) {
        return this.$http.get(
            `${this.apiRoot}/${ha_id}/issues/${issue_id}/journals/`,
            { params }
        );
    }

    addToJournal(haId, issueId, data) {
        return this.$http.post(
            `${this.apiRoot}/${haId}/issues/${issueId}/journals/`,
            data
        );
    }

    getCustomFields(companyId, params) {
        return this.$http.get(
            `/api/v1/companies/${companyId}/client_custom_fields/`,
            { params }
        );
    }
}

angular
    .module('app')
    .service('HousingAssociationsFactory', HousingAssociationsFactory);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/housing_association.factory.ts